const userStatusMap = new Map();

userStatusMap.set('A', 'Active');
userStatusMap.set('a', 'Active');
userStatusMap.set('Active', 'Active');
userStatusMap.set('active', 'Active');
userStatusMap.set('I', 'Inactive');
userStatusMap.set('i', 'Inactive');
userStatusMap.set('Inactive', 'Inactive');
userStatusMap.set('inactive', 'Inactive');

export { userStatusMap };